export default __webpack_public_path__ + "static/media/R0.9e572156.png";